class MultiSetupBufferDataBase {
  constructor() {
    this.AllData = [];
    this.pageData = new Map();
  }

  clear = () => {
    this.AllData = [];
    this.pageData = new Map();
  }

  getPage = (page) => {
    return this.pageData.get(page) || [];
  }

  initData = (data, pageSize) => {
    this.AllData = data;
    this.pageData = new Map();
    this.resetPage(pageSize || 20)
  }

  getData = () => {
    return this.AllData;
  }

  resetPage = (pageSize) => {
    pageSize = pageSize || 20;
    let pages = Math.ceil(this.AllData.length / pageSize);
    for (let i = 1; i <= pages; i++) {
      const currPageData = this.AllData.filter((item, index) => index >= (i - 1) * pageSize && index < i * pageSize);

      this.pageData.set(i, JSON.parse(JSON.stringify(currPageData)));
    }
    this.pages = pages;
  }

  setPage = (page, data) => {
    this.pageData.set(page, data);
  }

  getPages = () => {
    return this.pages;
  }

  getAllDataLength = () => {
    return this.AllData.length;
  }

  setData = (data) => {
    this.AllData = data;
  }

  initInterfaceList = (expCheckedList) => {
    const allData = this.AllData || [];
    const filterList = allData.filter(it => it.experiments && it.experiments.length && it.experiments.find(item => expCheckedList.includes(item.expName)));
    let interfaces = filterList.map(item => {
      const expNames = item.experiments.map(it => it.expName);
      return Object.keys(item.interfaceNames || {}).map(name => { return { name, id: item.interfaceNames[name], expNames } })
    }).flat(2);
    let existIds = [], newInterfaces = []
    for (let item of interfaces) {
      if (existIds.includes(item.id)) {
        continue;
      }
      existIds.push(item.id);
      newInterfaces.push({
        title: item.name,
        key: item.id,
      })
    }
    this.allInterfaceList = newInterfaces;
  }

  getInterfaceList = (expCheckedList) => {
    if (!expCheckedList) {
      return this.allInterfaceList
    }
    return (this.allInterfaceList || []).filter(item => !!item.expNames.find(it => expCheckedList.includes(it)))
  }
}

export const multiSetupPassiveDataBase = new MultiSetupBufferDataBase();

const multiSetupBufferDataBase = new MultiSetupBufferDataBase();
export default multiSetupBufferDataBase;